import { useEffect, useState } from "react"
import { FieldValues } from "react-hook-form"
import { ApiData } from "src/models/ApiData"
import { IOption } from "src/types"
import { IFormControl } from "src/types/index"
import { ISelectorProps } from "."
import { FormSelect } from "./FormSelect"

type Props<T extends FieldValues> = IFormControl<T> & Omit<ISelectorProps<string>, "options">
export const CountrySelect = <T extends FieldValues>(props: Props<T>) => {
  const [countries, setCountries] = useState<IOption[]>([])
  useEffect(() => {
    const fetchCountries = async () => {
      const options = (await ApiData.getSelectorList("country"))
        .map((item) => ({
          value: item.value,
          label: item.key,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
      setCountries(options)
    }
    fetchCountries()
  }, [])
  return (
    <FormSelect
      {...props}
      options={countries}
      leftSection={(option) =>
        // @ts-ignore
        option.value != null ? <div className={`iti-flag ${(typeof option === "string" ? option : option.value).toLowerCase()}`} /> : null
      }
    />
  )
}
